// modules
import { handleActions } from 'redux-actions'

// actions, constants
import {
  PATIENT_REWARDS_TABLE_LOADER,
  setPatientGamificationCompliance,
  setPatientGamificationLoader,
  setPatientGamificationMedal,
  setPatientGamificationRewardAchievements,
  setPatientGamificationRewardTasks,
  setPatientGamificationWallet,
  setPatientGamificationWalletHistory,
  setPatientGamificationActivitiesLoading,
  setPatientGamificationActivities,
  WALLET_HISTORY_TABLE_LOADER,
  setGamificationModules,
  setGamificationAchievements,
  setPatientMedicationCompliance
} from 'src/store/modules/patient/gamification'
import { deletePatientData } from 'src/store/modules/actionCreators'

const initialState = {
  wallet: {},
  walletHistory: [],
  tasks: [],
  achievements: [],
  medal: null,
  compliance: [],
  loaders: {
    [WALLET_HISTORY_TABLE_LOADER]: false,
    [PATIENT_REWARDS_TABLE_LOADER]: false
  },
  loading: false,
  gamificationActivities: [],
  gamificationModules: [],
  gamificationAchievements: [],
  medicationCompliance: {}
}

export default handleActions(
  {
    [setPatientGamificationWallet](state, { payload: wallet }) {
      return {
        ...state,
        wallet
      }
    },

    [setPatientGamificationRewardTasks](state, { payload: tasks }) {
      return {
        ...state,
        tasks
      }
    },

    [setPatientGamificationRewardAchievements](
      state,
      { payload: achievements }
    ) {
      return {
        ...state,
        achievements
      }
    },

    [setPatientGamificationWalletHistory](state, { payload: walletHistory }) {
      return {
        ...state,
        walletHistory
      }
    },

    [setPatientGamificationLoader](state, { payload: { loader, flag } }) {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          [loader]: flag
        }
      }
    },

    [setPatientGamificationCompliance](state, { payload: compliance }) {
      return {
        ...state,
        compliance
      }
    },

    [setPatientGamificationMedal](state, { payload: medal }) {
      return {
        ...state,
        medal
      }
    },
    [deletePatientData]() {
      return initialState
    },

    [setPatientGamificationActivitiesLoading](state, { payload: loading }) {
      return {
        ...state,
        loading
      }
    },

    [setPatientGamificationActivities](
      state,
      { payload: gamificationActivities }
    ) {
      return {
        ...state,
        gamificationActivities
      }
    },

    [setGamificationModules](state, { payload: gamificationModules }) {
      return {
        ...state,
        gamificationModules
      }
    },

    [setGamificationAchievements](
      state,
      { payload: gamificationAchievements }
    ) {
      return {
        ...state,
        gamificationAchievements
      }
    },

    [setPatientMedicationCompliance](state, { payload: medicationCompliance }) {
      return {
        ...state,
        medicationCompliance
      }
    }
  },
  initialState
)
